// extracted by mini-css-extract-plugin
export default {"ellipsisStaticLine":"textEllipsisStaticLine_ellipsisStaticLine__PRNd6"};